import React, { useState } from "react"
import VisibilitySensor from "react-visibility-sensor"

import { useSanity } from "../../../hooks/useSanity"
import { usePackages } from "../../../hooks/usePackages"
import { useTemplate } from "../../../hooks/useTemplate"

export const withSavings = Component => ({ name = "Savings", title: rawTitle, ...props }) => {
  const { sanityContent } = useSanity()
  const { global: locales } = useTemplate()

  const chartData = {
    default: {
      animate: { duration: 500 },
      style: { labels: { display: "none" } },
      padding: 0,
      labelRadius: 120,
      width: 400,
      height: 400,
      textAnchor: "middle",
    },
    start: {
      highest: {
        startAngle: 0,
        endAngle: 360,
        data: [
          { x: "", y: 100 },
          { x: "", y: 0 },
        ],
      },
      lowest: {
        startAngle: 0,
        endAngle: 360,
        data: [
          { x: "", y: 100 },
          { x: "", y: 0 },
        ],
      },
    },
    end: {
      highest: {
        startAngle: 45,
        endAngle: 405,
        data: [
          { x: "", y: 75 },
          { x: "", y: 25 },
        ],
      },
      lowest: {
        startAngle: 18,
        endAngle: 378,
        data: [
          { x: "", y: 90 },
          { x: "", y: 10 },
        ],
      },
    },
  }

  const { packages } = usePackages()
  const [animated, setAnimated] = useState(false)
  const [data, setData] = useState(chartData.start)
  const title = sanityContent(rawTitle)

  const charts = {
    highest: {
      ...data.highest,
      ...chartData.default,
    },
    lowest: {
      ...data.lowest,
      ...chartData.default,
    },
  }

  const handleVisibility = (visible: boolean) => {
    if (visible && !animated) {
      setData(chartData.end)
      setAnimated(true)
    }
  }

  Component.displayName = name
  return (
    <VisibilitySensor onChange={handleVisibility} minTopValue={400} partialVisibility>
      <Component {...props} charts={charts} locales={locales} packages={packages} title={title} visible={animated} />
    </VisibilitySensor>
  )
}
